import { Route } from "~/router";
import { api } from "./axios";

export const storePageActivity = (page: Route) => {
  return api.post<void>("/activity", undefined, {
    headers: {
      page,
    },
  });
};
